import { render, staticRenderFns } from "./ReportLinkCard.vue?vue&type=template&id=46a9c517&scoped=true&"
import script from "./ReportLinkCard.vue?vue&type=script&lang=js&"
export * from "./ReportLinkCard.vue?vue&type=script&lang=js&"
import style0 from "./ReportLinkCard.vue?vue&type=style&index=0&id=46a9c517&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46a9c517",
  null
  
)

export default component.exports